const stringToBoolean = (value) => value === 'true';

export default stringToBoolean;
